// i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './../locales/en.json';
import fr from './../locales/fr.json';



// Translation files
const resources = {
  en: { translation: en },
  fr: { translation: fr }
};

// Initialize i18n
i18n
  .use(LanguageDetector) // Detects browser language
  .use(initReactI18next) // Passes i18n instance to React
  .init({
    resources,
    lng: "fr",
    fallbackLng: 'fr', // Default language
    interpolation: {
      escapeValue: false, // React already escapes values
    },
  });

export default i18n;
